import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';

import { EpcotConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { Nullable } from '@frontend/sports/common/core/utils/extended-types';
import { ButtonType, DialogSettings, ModalDialogService, ModalRef } from '@frontend/sports/modal/feature';

@Injectable()
export class BetBuilderDialogService {
    private modalDialogRef: Nullable<ModalRef> = null;
    private readonly _doc = inject(DOCUMENT);

    constructor(
        private epcotConfig: EpcotConfig,
        private siteCore: Sitecore,
        private modalDialogService: ModalDialogService,
    ) {}

    showDialog(): Promise<ButtonType | undefined> {
        this.closeDialog();

        let settings: DialogSettings = {
            fit: true,
            isModalDialog: false,
            cssClass: 'edit-bab-overlay-dialog',
        };

        if (!this.epcotConfig.isEnabled) {
            settings = {
                ...settings,
                inColumn: true,
                container: this._doc.querySelector<HTMLElement>('.column-right .bet-column') || undefined,
            };
        }

        this.modalDialogRef = this.modalDialogService.openMessage(
            {
                title: this.siteCore.betBuilderEntainUI.messages?.EditBABOverlayTitle,
                firstParagraph: this.siteCore.betBuilderEntainUI.messages?.EditBABOverlayText,
                buttons: [
                    {
                        type: ButtonType.Ok,
                        text: this.siteCore.betBuilderEntainUI.messages?.EditBABOverlayOk ?? '',
                        cssClass: 'edit-overlay-ok-btn',
                    },
                    {
                        type: ButtonType.Cancel,
                        text: this.siteCore.betBuilderEntainUI.messages?.EditBABOverlayCancel ?? '',
                        cssClass: 'edit-overlay-cancel-btn',
                    },
                ],
            },
            settings,
        );

        return this.modalDialogRef.result.catch(() => {}).finally(() => (this.modalDialogRef = null));
    }

    closeDialog(): void {
        this.modalDialogRef?.close();
        this.modalDialogRef = null;
    }
}
